import { CommanderMonitoringFilterLogicalObject } from '../api/util/filter/filter.model';
import { actionsFeatureToggle } from '../../../featureToggle';
import SettingsCalls from '../../settings/api/SettingsCalls';
import { ZipDeviceControlUnit } from '../../controlUnit/controlUnit.model';
import { ShowLevelOption } from '../../groups/selectors/getLevelOfView';
import { AppDispatch } from '../../store.model';
import { FilterStoredProps, getPatchFilter } from '../selectors';
import useLabStateFilters from '../../../components/DeviceManager/Device/Monitoring/components/Lab/useLabStateFilters';

export interface FetchMetricsArgs {
  devicesControlUnits: ZipDeviceControlUnit[];
  digitalFilterObjectEvents: CommanderMonitoringFilterLogicalObject;
  analogFilterObjectEvents: CommanderMonitoringFilterLogicalObject;
  start: number;
  end: number;
  showLevelOption: ShowLevelOption;
  preferredTemperatureUnit: string;
  labStateFilters: ReturnType<typeof useLabStateFilters>;
}

export const updateFilter =
  (
    props: FilterStoredProps & { value: CommanderMonitoringFilterLogicalObject }
  ) =>
  (dispatch: AppDispatch) => {
    // path is another key that is not part of the types, and not should be
    const path: any = getPatchFilter(props);
    const settingsCalls = new SettingsCalls();
    const stringValue = JSON.stringify(props.value);
    settingsCalls.setSetting(path, stringValue);
    dispatch(
      actionsFeatureToggle.updateToggle({ name: path, value: stringValue })
    );
  };
